<template>
    <div class="export-detail">
        <div class="export-detail__label">
            {{ label }}
        </div>
        <div
            :class="{ 'export-detail__value--large': isValueLargeSize }"
            class="export-detail__value"
            >
            {{ value }}
        </div>
    </div>
</template>
<script setup lang="ts">
export interface Props {
    label: string
    value: string
    isValueLargeSize?: boolean
}

const props = withDefaults(defineProps<Props>(), { isValueLargeSize: false })
</script>
<style lang="scss">
.export-detail {
    display: flex;
    align-items: center;
    font-size: 16px;
    vertical-align: text-bottom;
    &__label {
        color: $grey-60;
    }
    &__value {
      color: $white;
      &--large {
        color: $white;
          font-size: 24px;
      }
    }
}
</style>
